import React from 'react';
import type { DashboardAggregates } from '../../types/machinesDashboard';

export default function MachinesWidget({ data }: { data: DashboardAggregates }) {
  const total = data.totals.online + data.totals.offline;
  const onlinePercent = total > 0 ? Math.round((data.totals.online / total) * 100) : 0;
  
  return (
    <div className="row g-3 mb-4">
      <div className="col-12 col-md-6 col-lg-3">
        <div className="dashboard-kpi-card success">
          <div className="card-body p-3">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="dashboard-kpi-title">Totale Macchine</div>
                <div className="dashboard-kpi-value" style={{ fontSize: '1.75rem' }}>{total}</div>
              </div>
              <div className="dashboard-kpi-icon" style={{ width: 40, height: 40, fontSize: 20 }}>
                <i className="bi bi-cpu" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-12 col-md-6 col-lg-3">
        <div className="dashboard-kpi-card success">
          <div className="card-body p-3">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="dashboard-kpi-title">Online</div>
                <div className="dashboard-kpi-value" style={{ fontSize: '1.75rem', color: '#059669' }}>{data.totals.online}</div>
                <div className="small text-muted">{onlinePercent}%</div>
              </div>
              <div className="dashboard-kpi-icon" style={{ width: 40, height: 40, fontSize: 20, background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1))', color: '#059669' }}>
                <i className="bi bi-check-circle-fill" />
              </div>
            </div>
            <div className="mt-2">
              <div className="dashboard-progress-modern">
                <div className="dashboard-progress-bar-modern" style={{ width: `${onlinePercent}%`, background: 'linear-gradient(90deg, #10b981, #059669)' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-12 col-md-6 col-lg-3">
        <div className="dashboard-kpi-card warning">
          <div className="card-body p-3">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="dashboard-kpi-title">Offline</div>
                <div className="dashboard-kpi-value" style={{ fontSize: '1.75rem', color: '#d97706' }}>{data.totals.offline}</div>
              </div>
              <div className="dashboard-kpi-icon" style={{ width: 40, height: 40, fontSize: 20, background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(217, 119, 6, 0.1))', color: '#d97706' }}>
                <i className="bi bi-x-circle-fill" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-12 col-md-6 col-lg-3">
        <div className="dashboard-kpi-card danger">
          <div className="card-body p-3">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <div className="dashboard-kpi-title">Allarmi</div>
                <div className="dashboard-kpi-value" style={{ fontSize: '1.75rem', color: '#dc2626' }}>{data.totals.alarmsOpen}</div>
              </div>
              <div className="dashboard-kpi-icon" style={{ width: 40, height: 40, fontSize: 20, background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(220, 38, 38, 0.1))', color: '#dc2626' }}>
                <i className="bi bi-exclamation-triangle-fill" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}